module.exports = __webpack_public_path__ + "static/img/icon-qrcode-android.38911198.png";